document.addEventListener('DOMContentLoaded', function () {
    var phoneInput = document.querySelector('input[name="your-phone"]');
    if (!phoneInput) return;

    phoneInput.addEventListener('input', function () {
        var v = this.value.replace(/\D/g, '').slice(0, 11);

        if (v.length > 2) {
            v = '(' + v.substring(0, 2) + ') ' + v.substring(2);
        }
        if (v.length > 9) {
            v = v.substring(0, 9) + '-' + v.substring(9);
        }

        this.value = v;
    });
});
